import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import moment from 'moment';

var TimePicker = /*#__PURE__*/function (_Component) {
  _inherits(TimePicker, _Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (type, index, value) {
      var newMoment = _this.props.selectedTime.clone();

      var amPm = type === 'amPm' ? value.toUpperCase() : newMoment.format('A');
      var hourOffset = amPm === 'AM' ? 0 : 12;
      var incomingHours = type === 'hour' ? value : newMoment.hour();
      var hourScale = amPm === 'AM' ? 12 : 24;
      var hours = (incomingHours + hourOffset) % hourScale;
      var minutes = "".concat(type === 'minute' ? value : newMoment.minute());

      if (minutes.length === 0) {
        minutes = "0".concat(minutes);
      }

      var timestring = "".concat(newMoment.format('YYYY'), "-").concat(newMoment.format('MM'), "-").concat(newMoment.format('DD'), " ").concat(hours, ":").concat(minutes, "-").concat(newMoment.format('ss'));
      var m = moment.utc(timestring, 'YYYY-MM-DD HH:mm:ss');

      _this.props.onTimeSelect(m);
    });

    var hcount = 1;
    var mncount = 0;
    var _hours = [];
    var _minutes = [];

    while (hcount <= 12) {
      _hours.push(hcount++);
    }

    while (mncount < 60) {
      _minutes.push(mncount++);
    }

    var allHours = _hours.map(function (h, i) {
      return {
        id: h,
        title: h
      };
    });

    var allMinutes = _minutes.map(function (d, i) {
      var _d = parseInt(d);

      if (_d < 10) {
        _d = "0".concat(_d);
      }

      return {
        id: i,
        title: _d
      };
    });

    var _amPm = [{
      id: 'AM',
      title: 'AM'
    }, {
      id: 'PM',
      title: 'PM'
    }];
    _this.state = {
      allHours: allHours,
      allMinutes: allMinutes,
      amPm: _amPm
    };
    return _this;
  }
  /** *********************************************************
   EVENT HANDLERS
   ***********************************************************/


  _createClass(TimePicker, [{
    key: "render",
    value:
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(DropDownMenu, {
        style: {
          width: '100%'
        },
        value: this.props.selectedTime.hour() % 12 || 12,
        onChange: function onChange(e, index, value) {
          return _this2.handleChange('hour', index, value);
        }
      }, this.state.allHours.map(function (i) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: i.id,
          primaryText: i.title,
          key: i.id
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(DropDownMenu, {
        style: {
          width: '100%'
        },
        value: this.props.selectedTime.minute(),
        onChange: function onChange(e, index, value) {
          return _this2.handleChange('minute', index, value);
        }
      }, this.state.allMinutes.map(function (i) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: i.id,
          primaryText: i.title,
          key: i.id
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(DropDownMenu, {
        style: {
          width: '100%'
        },
        value: this.props.selectedTime.format('A'),
        onChange: function onChange(e, index, value) {
          return _this2.handleChange('amPm', index, value);
        }
      }, this.state.amPm.map(function (i) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: i.id,
          primaryText: i.title,
          key: i.id
        });
      })))));
    }
  }]);

  return TimePicker;
}(Component);

export { TimePicker as default };